import store from 'store2'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { FormikConfig } from 'formik'
import { CallSubjectManagerContext } from '~/service/CallSubjectManager'
import { post } from '~/utils/api'
import { SipContext } from '~/service/SipConn'
import { FormattedMessage } from '~/translations/utils'
import trans from '~/translations/trans'
import { useHistory } from 'react-router'
import Button from '~/components/common/bulma/Button'
import DescribeSimple, { DescribeSimpleStatic } from './DescribeSimple'
import DescribeTelemarketing, {
  DescribeTelemarketingStatic,
} from './DescribeTelemarketing'
import {
  DescribeSimpleValues,
  DescribeTelemarketingValues,
  SubmitForm,
} from './types'
import { CallOnShow } from '../../types'

type Props = {
  call: CallOnShow
  inPhone?: boolean
  duringCall?: boolean
  onDescribed?: () => void
  onStartSubmit?: () => void
  submitRef?: React.MutableRefObject<SubmitForm | undefined>
}

export const setStorage = (id: number, form: any) =>
  store.set('call_desc_' + id, JSON.stringify(form))

const removeStorage = (id: number) => store.remove('call_desc_' + id)

const getStorage = (id: number) => {
  const item = store.get('call_desc_' + id)

  return item ? JSON.parse(item) : null
}

const Describe: React.FC<Props> = ({
  call,
  inPhone = false,
  duringCall = false,
  onStartSubmit = () => {},
  onDescribed,
  submitRef,
}) => {
  const { activeCall, incomingCall } = useContext(SipContext)
  const history = useHistory()
  const [describeFirst, setDescribeFirst] = useState(false)
  const unblockRef = useRef<() => void>()
  const describedRef = useRef(call.described)
  const { subjects } = useContext(CallSubjectManagerContext)
  const [edit, setEdit] = useState(!call.described)
  const [convertTmToSimple, setConvertTmToSimple] = useState(
    !call.described && call.tmContact && !call.outbound ? undefined : false
  )

  describedRef.current = call.described

  useEffect(() => {
    // blokujemy tylko w zakładce /phone, tylko po rozłączeniu (!activeCall)
    // odblokowywane jest niżej, przy wykryciu incomingCall, lub po wysłaniu formularza
    if (!inPhone || activeCall) {
      return
    }

    const unblock = history.block(() => {
      setDescribeFirst(true)

      return false
    })

    window['describeFirst'] = () => setDescribeFirst(true)

    unblockRef.current = () => {
      unblock()
      setDescribeFirst(false)
      window['describeFirst'] = undefined
    }
  }, [activeCall])

  useEffect(
    () => () => {
      // uruchamia się przy wyjściu z komponentu, by zapisać zmiany na serwerze

      if (describedRef.current) {
        return
      }

      const values = getStorage(call.id)

      if (values) {
        post('calls/' + call.id + '/describe/0', getStorage(call.id))
      }
    },
    []
  )

  useEffect(() => {
    if (incomingCall) {
      if (unblockRef.current) {
        unblockRef.current()
      }
    }
  }, [incomingCall])

  const formikConfig: FormikConfig<any> = {
    initialValues: call.described
      ? call.tmContact
        ? ({
            ...call,
            success: call.tmSuccess,
            statuses: call.tmStatuses,
            failReason: call.tmFailReason ? call.tmFailReason + '' : '',
            customStatusId: call.tmCustomStatusId,
            customStatusNote: call.tmCustomStatusNote || '',
          } as DescribeTelemarketingValues)
        : ({
            ...call,
            success: subjects.length && !call.subjects.length ? false : true,
          } as DescribeSimpleValues)
      : getStorage(call.id) || null,
    validate: values => {
      setStorage(call.id, values)
    },
    onSubmit: async (values, formik) => {
      if (duringCall) {
        return
      }

      onStartSubmit()

      await post('calls/' + call.id + '/describe/1', values)

      setEdit(false)

      removeStorage(call.id)

      if (unblockRef.current) {
        unblockRef.current()
      }

      if (onDescribed) {
        onDescribed()
      }
    },
  }

  return (
    <>
      {describeFirst && (
        <div className="notification is-warning">
          <FormattedMessage id="call / describe / describe first" />
        </div>
      )}

      <h2>
        {call.described && (
          <Button onClick={() => setEdit(!edit)}>{trans.general.edit()}</Button>
        )}

        <span className="far fa-pencil" />
        <FormattedMessage id="call / describe / title" />
      </h2>

      <div className="call-show-describe">
        {!call.tmContact &&
          (call.described && !edit ? (
            <DescribeSimpleStatic call={call} />
          ) : (
            <DescribeSimple
              call={call}
              submitRef={submitRef}
              formikConfig={formikConfig}
              showSubmit={!inPhone}
            />
          ))}

        {convertTmToSimple === undefined ? (
          <div className="notification is-warning is-light">
            <p>
              <FormattedMessage id="call / describe / convert telemarketing / desc" />
            </p>

            <div className="buttons">
              <Button
                icon="far fa-bullhorn"
                onClick={() => setConvertTmToSimple(false)}
              >
                <FormattedMessage id="call / describe / convert telemarketing / yes" />
              </Button>
              <Button onClick={() => setConvertTmToSimple(true)}>
                <FormattedMessage id="call / describe / convert telemarketing / not" />
              </Button>
            </div>
          </div>
        ) : (
          call.tmContact &&
          (call.described && !edit ? (
            <DescribeTelemarketingStatic call={call} />
          ) : convertTmToSimple ? (
            <DescribeSimple
              submitRef={submitRef}
              call={call}
              formikConfig={formikConfig}
              showSubmit={!inPhone}
            />
          ) : (
            <DescribeTelemarketing
              submitRef={submitRef}
              call={call}
              formikConfig={formikConfig}
              showSubmit={!inPhone}
            />
          ))
        )}
      </div>
    </>
  )
}

//

export default Describe
